import { memo } from "react";

import { QuestionCampaignEmailTemplates as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/email-templates/campaign/email-templates";

import { useCampaignEmailTemplates } from "./hooks";

export const QuestionCampaignEmailTemplates = memo(() => {
	const { onSetMailTemplate, hotelEmailAddress, mailTemplate, onSendTestEmailCreated } = useCampaignEmailTemplates();

	return (
		<Question
			mailTemplate={mailTemplate}
			onSetMailTemplate={onSetMailTemplate}
			hotelEmailAddress={hotelEmailAddress}
			onSendTestEmailCreated={onSendTestEmailCreated}
		/>
	);
});

QuestionCampaignEmailTemplates.displayName = "QuestionCampaignEmailTemplates";
